function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 18.6 17.84"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M18.14 8.26L15 11.32a.49.49 0 00-.15.44l.74 4.31a1.49 1.49 0 01-.6 1.48 1.51 1.51 0 01-.89.3 1.53 1.53 0 01-.71-.18l-3.88-2a.53.53 0 00-.47 0l-3.88 2a1.48 1.48 0 01-.7.17 1.52 1.52 0 01-.89-.29A1.49 1.49 0 013 16.07l.74-4.31a.5.5 0 00-.15-.44L.46 8.26a1.51 1.51 0 01.83-2.58L5.63 5A.5.5 0 006 4.77L7.94.85a1.51 1.51 0 012.71 0l1.75 3.56c.3.58.4.48.42.65s-.28.44-.46.62-.53.53-.66.53-.21-.09-.38-.3a4 4 0 01-.32-.5L9.3 1.89 7.51 5.52a2.19 2.19 0 01-1.65 1.2l-4 .58 2.9 2.82A2.19 2.19 0 015.39 12l-.68 4 3.57-1.88a2.2 2.2 0 012 0L13.89 16l-.68-4a2.22 2.22 0 01.29-1.5l4.43-4.43a.17.17 0 01.07-.02h.08a.12.12 0 01.05 0 1.53 1.53 0 01.34.58 1.5 1.5 0 01-.33 1.63z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M7.38 8.26l2 2 6-6a1 1 0 111.42 1.41l-6.72 6.72a1 1 0 01-1.43 0L6 9.69a1 1 0 011.38-1.43z"
})));